import { makeHttpRequest } from "@/shared";

export const deleteExpenseTypes = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/expense/type/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
